import type { QuizConfig } from "../types"

/**
 * Live Palmistry 4.0 quiz flow (Figma "Dark Mode").
 * Left/right palm capture screens are intentionally omitted in this iteration.
 */
export const palmistryQuiz: QuizConfig = {
  id: "palmistry",
  name: "Palmistry",
  steps: [
    {
      id: "name",
      type: "input",
      title: "What's your name?",
      subtitle: "We'll use this to personalize your experience",
      placeholder: "Enter your name",
      required: true,
    },
    {
      id: "gender",
      type: "single-choice",
      layout: "icons",
      title: "What's your gender?",
      subtitle: "This helps us shape your readings more accurately",
      required: true,
      options: [
        { label: "Male", value: "male", icon: "mars" },
        { label: "Female", value: "female", icon: "venus" },
        { label: "Other", value: "other", icon: "ellipsis" },
      ],
    },
    {
      id: "dob",
      type: "date",
      dateMode: "dob",
      title: "What's your date of birth?",
      subtitle: "We'll use this to calculate your zodiac and birth chart",
      required: true,
    },
    {
      id: "tob",
      type: "time",
      title: "Do you know your birth time?",
      subtitle: "This helps reveal a more accurate birth chart and personal reading",
      required: true,
      secondaryAction: { label: "I don't remember", value: "unknown" },
    },
    {
      id: "marital",
      type: "single-choice",
      layout: "list",
      title: "What's your marital status?",
      subtitle: "We'll use this to tailor your relationship reading",
      required: true,
      options: [
        { label: "Free", value: "free" },
        { label: "Soulmate", value: "soulmate" },
        { label: "Married", value: "married" },
        { label: "Difficult", value: "difficult" },
      ],
    },
    {
      id: "analysis",
      type: "analysis",
      title: "Analyzing the unique shape of your palm",
      checklist: [
        "Scanning your palm structure",
        "Detecting key lines and markers",
        "Interpreting your natural energy patterns",
      ],
    },
    {
      id: "email",
      type: "email",
      title: "Where should we send your personal report?",
      placeholder: "Enter your email",
      required: true,
      legalNote: true,
    },
  ],
}
